import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';

export type CustomFieldTyp = 'TEXT' | 'NUMBER' | 'DATE' | 'BOOLEAN' | 'SELECT' | 'TEXTAREA';

export interface CustomFieldDefinition {
  feld_id: number;
  tabelle: string;
  schluessel: string;
  label: string;
  typ: CustomFieldTyp;
  optionen?: string[] | null;
  pflicht: boolean;
  default_wert?: string | null;
  reihenfolge: number;
  beschreibung?: string | null;
  sichtbar_fuer?: string[] | null;
  aktiv: boolean;
  erstellt_am?: string | null;
}

export function useCustomFields(tabelle: string, authToken: string) {
  const [definitions, setDefinitions] = useState<CustomFieldDefinition[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!authToken) return;
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get<CustomFieldDefinition[]>(
        `${API_URL}/api/custom-fields`,
        {
          params: { tabelle, nur_aktive: true },
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );
      setDefinitions(res.data);
    } catch (e: any) {
      setError(e.response?.data?.detail || 'Custom-Fields konnten nicht geladen werden');
    } finally {
      setLoading(false);
    }
  }, [tabelle, authToken]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { definitions, loading, error, refresh };
}
